

// Widget Scripts
import swiperWidgetMainFeature from './js/widgets/swiperWidgetMainFeature.js';
import cardWidgetSecondFeature from './js/widgets/cardWidgetSecondFeature.js';
import cardWidgetFirstFeature from './js/widgets/cardWidgetFirstFeature.js';
import cardWidgetThirdFeature from './js/widgets/cardWidgetThirdFeature.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import * as socialNetworkWidget from './js/widgets/socialNetworkWidget';
import videoWidget from './js/widgets/videoWidget.js';



import sponsors from './js/widgets/sponsors.js';
import staticSponsorsWidget from './js/widgets/staticSponsorsWidget.js';


// Custom Theme Scripts
import './js/localjs.js';
// import './js/cartPopUpFestivalLights.js';
// import './js/checkoutPopUp.js';
import './js/popUpByIProdId.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    swiperWidgetMainFeature();

    cardWidgetThirdFeature();

    cardWidgetFirstFeature();
    cardWidgetSecondFeature();

    multiScheduleFeature();


    $(window).load(function () {
      socialNetworkWidget.facebookfeed(true);
      socialNetworkWidget.instafeed(true);
      videoWidget();
    })
  });

}

$(document).ready(function () {
  sponsors();
  staticSponsorsWidget();
})

